import React from 'react';
import PropTypes from 'prop-types';

const CalendarLabel = props => {
  const { calendarColor, title, ...labelProps } = props;
  return (
    <div className='calendar__label' {...labelProps}>
      <span className={`calendar__label__dot-color--${calendarColor}`} />
      <span>{title}</span>
    </div>
  );
};

CalendarLabel.propTypes = {
  calendarColor: PropTypes.oneOf([
    'red-green',
    'primary',
    'secondary',
    'tertiary',
    'quaternary',
    'quinary',
    'senary',
    'septenary',
    'octonary',
    'nonary'
  ]).isRequired,
  title: PropTypes.string.isRequired
};

export default CalendarLabel;
